export default "__VITE_ASSET__BAi6To_K__"